import { Box } from '@chakra-ui/layout'
import { HeadingPages } from '../../../components/HeadingPages'
import * as T from '../../../components/Table'
import { TableContainer } from '@chakra-ui/table'
import { useForm } from 'react-hook-form'
import { api } from '../../../services/api'
import { useQuery } from 'react-query'
import { useToast } from '@chakra-ui/react'
import { ListItem } from './ListItem'
import { Columns } from './Columns'
import { Form } from './Form'
import { useSearchParams } from 'react-router-dom'
import { format } from 'date-fns'
import { formatPrice } from '../../../utils/formatPrice'

async function getListInfoPagamento({ query }) {
  const response = await api.get('/pagamento/historico', {
    params: {
      buscar: query,
    },
  })

  if (response.status !== 200) {
    throw new Error(response.data.erros.message)
  }

  const data = response.data.map((item) => {
    return {
      ...item,
      dt_mov: item.dt_mov ? format(new Date(item.dt_mov), "dd/MM/yyyy 'as' HH:mm") : '',
      valor: item.valor ? formatPrice(item.valor) : '',
    }
  })

  return data
}

export function HistoricoPagamento() {
  const [searchParams] = useSearchParams()

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
    duration: 5000,
  })

  const { data: listaHistoricoPagamento = [], isLoading } = useQuery({
    queryKey: ['historico-pagamento', searchParams.get('query')],
    queryFn: () => getListInfoPagamento({ query: searchParams.get('query') }),
    staleTime: 1000 * 60 * 5,
    enabled: !!searchParams.get('query'),
    refetchOnWindowFocus: false,
    onError: (error) => {
      toast({
        title: 'Erro ao buscar histórico de pagamento',
        description: error['response']['data'].erros.message,
        status: 'error',
      })
    },
  })

  return (
    <>
      <HeadingPages name="Histórico de Pagamentos" />

      <Box maxWidth="1600px" mx="auto" px="1rem" py="1rem" w="100%">
        <Form isLoading={isLoading} />

        <TableContainer>
          <T.Table borderCollapse="collapse">
            <Columns />
            <ListItem list={listaHistoricoPagamento} />

            {listaHistoricoPagamento?.length === 0 && (
              <T.Tbody>
                <T.Tr>
                  <T.Td colSpan="7">Nenhum registro encontrado</T.Td>
                </T.Tr>
              </T.Tbody>
            )}
          </T.Table>
        </TableContainer>
      </Box>
    </>
  )
}
